<nb-card style="min-height: 700px">
  <nb-card-header>
    <h3 style="position: relative" i18n>Cleaning Time Estimate</h3>
  </nb-card-header>
  <nb-card-body>
    <div style="min-height: 700px; overflow: auto; padding: 1.143em; box-sizing: border-box">
      <div class="container" style="max-width: 800px">
        <div style="margin: 10px">
          <ng-container>
            <div class="formgroupmodal">
              <div>
                <h4 i18n>Select a robot:</h4>
                <br />
                <div class="row">
                  <div class="col-auto" style="width: 100%">
                    <ng-select
                      [(ngModel)]="selectedRobot"
                      [groupBy]="groupByFn"
                      (change)="robotIdAdd($event)"
                      (clear)="robotIdClear()"
                    >
                      <ng-container>
                        <ng-option *ngFor="let p of commonRobots" [value]="p"> {{ p.name }} - {{ p.id }} </ng-option>
                      </ng-container>
                    </ng-select>
                  </div>
                </div>
              </div>
              <br />
            </div>
            <div *ngIf="spin" class="wrapper">
              <div class="centered">
                <app-spinner></app-spinner>
              </div>
            </div>
            <form *ngIf="cleaningTimeEstimates?.length" (ngSubmit)="onSubmit()">
              <h5 i18n>Estimates</h5>
              <br />
              <div *ngFor="let estimate of cleaningTimeEstimates">
                <nb-card accent="success" style="width: 100%; margin: auto">
                  <nb-card-body>
                    <div class="row" *ngIf="estimate.map_id">
                      <div class="col"><div i18n>Map ID:</div></div>
                      <div class="col">
                        {{ estimate.map_id }}
                      </div>
                    </div>
                    <br />
                    <div class="row" *ngIf="estimate.pmap_id">
                      <div class="col"><div i18n>Pmap ID:</div></div>
                      <div class="col">
                        {{ estimate.pmap_id }}
                      </div>
                    </div>
                    <br />
                    <nb-accordion>
                      <nb-accordion-item *ngFor="let area of estimate.cleaning_time_estimates">
                        <nb-accordion-item-header i18n>Area ID: {{ area.area_id }}</nb-accordion-item-header>
                        <nb-accordion-item-body>
                          <table *ngIf="area.display?.rows?.length" class="table table-sm">
                            <thead>
                              <tr>
                                <th *ngFor="let col of area.display.columns">{{ col.label }}</th>
                                <th i18n>Value (seconds)</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of area.display.rows; let i = index">
                                <td *ngFor="let col of area.display.columns">{{ row.paramDisplayByKey[col.key] }}</td>
                                <td>
                                  <input
                                    nbInput
                                    fullWidth
                                    fieldSize="small"
                                    type="number"
                                    min="0"
                                    step="1"
                                    name="estimateValue-{{ estimate.robot_id }}-{{ area.area_id }}-{{ i }}"
                                    [(ngModel)]="area.estimates[i].value"
                                    (ngModelChange)="syncValueDisplay(area, i)"
                                  />
                                  <small class="text-hint d-block mt-1">{{ row.valueDisplay }}</small>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </nb-accordion-item-body>
                      </nb-accordion-item>
                    </nb-accordion>
                  </nb-card-body>
                </nb-card>
              </div>
              <div style="margin-top: 10px">
                <button type="submit" nbButton status="primary" [disabled]="submitting">
                  <span *ngIf="!submitting" i18n>Submit</span>
                  <span *ngIf="submitting" i18n>Saving...</span>
                </button>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
